import { useState, useEffect, memo } from 'react';

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';

import { Box, Flex, Image } from '@chakra-ui/react';
import { joinPublicDsr, resetJoinPublicDsr } from '../../actions/public-dsr-actions.js'
import logo from '../../../global/styles/images/launchdeck_logo.svg';
import { getThisUserIdToken, redirectToNewPage } from '../../../global/helpers/global-helpers.js';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton.jsx';
import { getUserProfile } from '../../../profile/actions/users-profile-actions';
import UserProfileImageDisplay from '../../../global/components/helper-components/components/UserProfileImageDisplay.jsx';
import { getFullName } from '../../../profile/helpers/user-helper.js';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal.jsx';

function LoggedInUserJoinRoomModal({
  dsrId,
  handleCloseModal,
  // Actions
  joinPublicDsr,
  resetJoinPublicDsr,
  getUserProfile,
  // Redux states
  userAccountProfile,
  joinPublicDsrOutcome,
  dsrDisplayLogoImages,
  isMobileView,
  userProfilePicture,
  dsrTitle
}) {

  // Data
  const [userNameDisplay, setUserNameDisplay] = useState("")
  // UX
  const [showLoader, setShowLoader] = useState(false)
  const [showAudienceLogo, setShowAudienceLogo] = useState(true);


  useEffect(() => {
    if (joinPublicDsrOutcome) {
      const { nextStep, processSuccessful } = joinPublicDsrOutcome || {}

      if (processSuccessful && nextStep) {
        switch (nextStep) {

          case ("only-redirect-to-dsr"): {
            redirectToNewPage(dsrId ? `/dsr/${dsrId}` : `/home`)

            break;
          }
          default: {

            break;
          }
        }
      }

      resetJoinPublicDsr()
    }
  }, [joinPublicDsrOutcome, resetJoinPublicDsr])

  useEffect(() => {
    if (getUserProfile && !userAccountProfile) {
      getUserProfile(
        {
          getUserInfo: true
        }
      )
    }
  }, [getUserProfile])


  useEffect(() => {
    if (userAccountProfile) {
      const displayName = getFullName(userAccountProfile);
      displayName && setUserNameDisplay(displayName)
    }
  }, [userAccountProfile])



  const handleLoginJoinRoom = () => {
    const joinPublicDsrPayload = {
      event: 'add-logged-in-user-to-room',
      userIdToken: getThisUserIdToken(),
      dsrId: dsrId
    }

    joinPublicDsr(joinPublicDsrPayload)
    setShowLoader(true)
  }


  const handleClickModalCloseButton = () => {
    setShowLoader(false)
    handleCloseModal()
  }

  const renderContent = () => {
    return (<>
      <Flex fontSize='1em' color='brandDark.500' fontWeight='600' textAlign='center'>
        You are about to join {dsrTitle ? <Box as="span" ml={2} fontStyle={'italic'}>{dsrTitle}</Box> : "this Room"}
      </Flex>

      <Flex fontSize='0.875em' color='gray.500' mb='1em' textAlign='center'>
        Connect with everyone. Ask questions. Get insights.
      </Flex>

      <Box w="100%" align="center">
        <Box px='1em' my='1em'>
          <Flex align='center' w='100%' maxW='18em' direction='column' gap='2em'>
            <Flex py='1em' justify='center' px='3em' rounded='0.25em' border='1px solid' borderColor='gray.200' bg='gray.50' minW='15em' w='100%' boxShadow='xs'>
              <Flex direction='column' w='100%' justify='center' align='center' gap='1em'>
                <UserProfileImageDisplay name={userNameDisplay} size='3em' profilePicture={userProfilePicture} />
                <Box fontSize='0.875em'>
                  {userNameDisplay}
                </Box>
              </Flex>
            </Flex>

            <LaunchdeckButton bg='brand.500' color='gray.50' px='5em' w='100%' label='Join Room' loadingLogic={showLoader} onClick={() => handleLoginJoinRoom()} />

          </Flex>
        </Box>
      </Box>
    </>)
  }

  const renderLogos = () => {
    const {
      displayedAudienceLogo,
      displayedHostLogo
    } = dsrDisplayLogoImages || {};

    if (displayedHostLogo) {
      return (
        <Flex w='100%' justify='center'>
          <Image src={displayedHostLogo} alt="Host Logo" width='50%' minWidth='1em' maxWidth='5em' mb='2em' />
          {displayedAudienceLogo && showAudienceLogo && <Image src={displayedAudienceLogo} alt="Guest logo" onError={() => setShowAudienceLogo(false)} width='50%' minWidth='1em' maxWidth='5em' mb='2em' ml='1.5em' />}
        </Flex>
      )

    } else {
      return (
        <Flex w='100%' justify='center'>
          <Image src={logo} alt="Launchdeck Logo" width='50%' minWidth='1em' maxWidth='5em' mb='2em' />
        </Flex>
      )
    }
  }


  const displayContent = () => {
    return (
      <Box w='100%' py='1em'>
        <Flex direction='column' justify='center' alignItems='center' px={isMobileView ? '1em' : '2em'} w='100%'>
          {renderLogos()}
          {renderContent()}
        </Flex>
      </Box>
    )
  }


  return (
    <LaunchdeckModal
      handleCloseModal={() => handleClickModalCloseButton()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}


const mapStateToProps = (state) => ({
  dsrDisplayLogoImages: state.dsrDisplayLogoImages.dsrDisplayLogos,
  joinPublicDsrOutcome: state.joinPublicDsrOutcome.results.data,
  isMobileView: state.mobileViewMode.isMobileView,
  userAccountProfile: state.userProfile.accountUserProfile,
  userProfilePicture: state.thisUserProfilePicture.result,
  dsrTitle: state.dsrTitle.title
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      joinPublicDsr,
      resetJoinPublicDsr,
      getUserProfile
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(LoggedInUserJoinRoomModal)))
